import { render, staticRenderFns } from "./HeadPictur.vue?vue&type=template&id=1a433394&scoped=true&"
import script from "./HeadPictur.vue?vue&type=script&lang=ts&"
export * from "./HeadPictur.vue?vue&type=script&lang=ts&"
import style0 from "./HeadPictur.vue?vue&type=style&index=0&id=1a433394&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a433394",
  null
  
)

export default component.exports